import React from "react";

import { StaticTableFilterHook } from "commons/hooks/useStaticTableFilter";

import { GridItem, GridRow } from "commons/ui/Grid";
import Select from "commons/ui/input/Select";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { CatalogListHook } from "hooks/list/useCatalogList";

function CatalogExtraFilters({ staticFilterHook }: { staticFilterHook: StaticTableFilterHook }) {
    const { setValue, form } = staticFilterHook;

    return (
        <GridRow>
            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Area pubblica"}
                    options={[
                        { value: "", label: "Tutti" },
                        { value: true, label: "Visibile" },
                        { value: false, label: "Non visibile" },
                    ]}
                    value={form.front_visible}
                    setValue={setValue}
                    path={"front_visible"}
                    showPlaceholder
                />
            </GridItem>

            <GridItem className={"col-xs-12-3"}>
                <Select
                    label={"Area riservata"}
                    options={[
                        { value: "", label: "Tutti" },
                        { value: true, label: "Visibile" },
                        { value: false, label: "Non visibile" },
                    ]}
                    value={form.reserved_area_visible}
                    setValue={setValue}
                    path={"reserved_area_visible"}
                    showPlaceholder
                />
            </GridItem>
        </GridRow>
    );
}

function CatalogTableFilters({ catalogListHook }: { catalogListHook: CatalogListHook }) {
    const { onSearchFilterChange, staticFilterHook, filterSearchHook } = catalogListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    const { clearStaticFilters } = staticFilterHook;

    const clearAllFilters = React.useCallback(() => {
        clearFilters();
        clearStaticFilters();
    }, [clearStaticFilters, clearFilters]);

    return (
        <FiltersContainer
            applyFilters={applyFilters}
            clearFilters={clearAllFilters}
            extraFilters={<CatalogExtraFilters staticFilterHook={staticFilterHook} />}
            openDefault={staticFilterHook.filters.length > 0}
        >
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.title}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default CatalogTableFilters;
